import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import NavigationDropdown, { NavigationOption } from 'modules/views/shared/NavigationDropdown';
import { useStyles } from '../styles';

export const DrugTestingHeader: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.header} data-testid="my-drug-testing-header">
      <p className={classes.title} data-testid="my-drug-testing-title">
        {t('myDrugTesting.title')}
      </p>
      <NavigationDropdown excludeOptions={[NavigationOption.MY_DRUG_TESTING]} />
    </Box>
  );
};
